import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../pipes/pipes.module";
import { MaterialModule } from "../../components/material/material.module";
import { NoticiaService } from "../../providers/noticia.service";
import { CrearNoticiaComponent } from "./crear-noticia/crear-noticia.component";
import { CrearNoticiaDialog } from "./crear-noticia/crear-noticia-dialog/crear-noticia-dialog.component";
import { DetalleNoticiaComponent } from "./detalle-noticia/detalle-noticia.component";
import { EditarNoticiaComponent } from "./editar-noticia/editar-noticia.component";
import { EditarNoticiaDialog } from "./editar-noticia/editar-noticia-dialog/editar-noticia-dialog.component";
import { EliminarNoticiaComponent } from "./eliminar-noticia/eliminar-noticia.component";
import { EliminarNoticiaDialog } from "./eliminar-noticia/eliminar-noticia-dialog/eliminar-noticia-dialog.component";
import { NoticiaComponent } from "./noticia/noticia.component";
import { VerNoticiasComponent } from "./ver-noticias/ver-noticias.component";
import { ArchivoNoticiaModule } from "./archivos-noticia/archivo-noticia.module";
import { RouterModule } from "@angular/router";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        MaterialModule,
        RouterModule,
        ArchivoNoticiaModule,
    ],
    declarations: [
        CrearNoticiaComponent,
        CrearNoticiaDialog,
        DetalleNoticiaComponent,
        EditarNoticiaComponent,
        EditarNoticiaDialog,
        EliminarNoticiaComponent,
        EliminarNoticiaDialog,
        NoticiaComponent,
        VerNoticiasComponent,
    ],
    providers: [
        NoticiaService
    ],
    entryComponents: [
        CrearNoticiaDialog,
        EditarNoticiaDialog,
        EliminarNoticiaDialog,
    ],
    exports: [
        CrearNoticiaComponent,
        DetalleNoticiaComponent,
        EditarNoticiaComponent,
        EliminarNoticiaComponent,
        NoticiaComponent,
        VerNoticiasComponent,
    ]
})
export class NoticiaModule { }